import * as THREE from 'three'
import { findObjectWithHandlers } from '../utils/helper_functions/findObjectWithHandlers'

export const raycastMouseEvents = ({
  camera,
  renderer,
  sceneMeshes,
  events
}) => {
  const raycaster = new THREE.Raycaster()
  let lastIntersected = null
  let lastIntersectedTap = null

  const clickHandler = (event) => {
    const mouse = {
      x: (event.offsetX / renderer.domElement.clientWidth) * 2 - 1,
      y: -(event.offsetY / renderer.domElement.clientHeight) * 2 + 1
    }

    const rect = renderer.domElement.getBoundingClientRect()
    const positionOfSeat = {
      x: event.clientX - rect.x,
      y: event.clientY - rect.y
    }

    raycaster.setFromCamera(mouse, camera)

    const intersected = raycaster.intersectObjects(sceneMeshes, true)
    if (intersected[0]) {
      if (window.isMobile) {
        if (lastIntersectedTap) {
          events.onMouseOut({
            seat: lastIntersectedTap
          })
        }
        events.onTap({
          seat: findObjectWithHandlers(intersected[0]),
          position: positionOfSeat
        })
        lastIntersectedTap = findObjectWithHandlers(intersected[0])
      } else {
        events.onClick({ seat: findObjectWithHandlers(intersected[0]) })
      }
    }
  }

  const mouseOverHandler = (event) => {
    const mouse = {
      x: (event.offsetX / renderer.domElement.clientWidth) * 2 - 1,
      y: -(event.offsetY / renderer.domElement.clientHeight) * 2 + 1
    }

    const rect = renderer.domElement.getBoundingClientRect()
    const positionOfSeat = {
      x: event.clientX - rect.x,
      y: event.clientY - rect.y
    }

    raycaster.setFromCamera(mouse, camera)
    const intersected = raycaster.intersectObjects(sceneMeshes, true)

    if (intersected[0] && !lastIntersected) {
      lastIntersected = findObjectWithHandlers(intersected[0])
      events.onMouseOver({
        seat: findObjectWithHandlers(intersected[0]),
        position: positionOfSeat
      })
    } else if (intersected[0] && lastIntersected) {
      events.onMouseOut({
        seat: lastIntersected
      })
      lastIntersected = findObjectWithHandlers(intersected[0])
      events.onMouseOver({
        seat: findObjectWithHandlers(intersected[0]),
        position: positionOfSeat
      })
    } else if (!intersected[0] && lastIntersected) {
      events.onMouseOut({
        seat: lastIntersected
      })
      lastIntersected = null
    }
  }

  return {
    handleClick: clickHandler,
    handleMouseOver: mouseOverHandler
  }
}
